<template>
  <v-container class="d-flex justify-center align-center" style="height: 100vh;">
    <v-card class="pa-5" width="400">
      <v-card-title class="text-h5 text-center">Login</v-card-title>
      <v-card-text>
        <v-form @submit.prevent="handleLogin">
          <v-text-field
            v-model="username"
            label="Username"
            outlined
            dense
            required
          ></v-text-field>
          <v-text-field
            v-model="password"
            label="Password"
            type="password"
            outlined
            dense
            required
          ></v-text-field>
          <div class="d-flex flex-column align-center mt-4" style="width: 100%;">
  <v-btn color="primary" @click="handleLogin" block>
    Login
  </v-btn>
  <v-btn text small @click="$router.push('/forgot-password')" block class="mt-2">
    Forgot Password?
  </v-btn>
</div>


          <v-alert v-if="error" type="error" dense class="mt-3">
            {{ error }}
          </v-alert>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'UserLogin',
  data() {
    return {
      username: '',
      password: '',
      error: null,
    };
  },
  methods: {
    ...mapActions(['login']),
    async handleLogin() {
      try {
        await this.login({
          username: this.username,
          password: this.password,
        });
        this.$root.showSnackbar('You have successfully logged in.');
        this.$router.push('/');
      } catch (err) {
        this.error = 'Invalid username or password';
      }
    },
  },
};
</script>
